import { HttpClient } from './HttpClient.js';


export const EstadisticaService = {
    
    /************************** GESTIONES **************************/
    async getActionCode(){
        return await HttpClient.get('/management/get-action-code').then(response => response);
    },

    async getGruposAdmin(profileType, distpatch){
        return await HttpClient.get(`/group/get-groups-by-profile/${profileType}/${distpatch}`).then(response => response);
    },

    async getGruposSupervisor(id){
        return await HttpClient.get(`/group/get-groups-by-supervisor/${id}`).then(response => response);
    },

    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async getUsersByGroups(idGrupo){
        return await HttpClient.get('/group/get-users-by-group/'+idGrupo).then(response => response)
        
    },

    getDespachosByUser: async function(idUsuario){
        return await HttpClient.get(`/dispatch/get-by-responsible/${encodeURIComponent(idUsuario)}`).then(response => response)
    },

    /************************** COBRANZA **************************/
    
    async getPaymentsStatistics(request){
        return await HttpClient.postJSON('/statistics/get-payments-statistcs', request).then(response => response)
    },

    async getDataGraficas(data){
        return await HttpClient.postJSON('/statistics/get-management-statistics',data).then(response => response)
    },

    async getDatGrficasByCode(data){
        return await HttpClient.postJSON('/statistics/get-management-statistics-by-code',data).then(response => response)
    },


    /************************** METAS **************************/
    async getGeneralGoals (typeGoal, status, id) {
        return await HttpClient.get(`/goals/get-general-goals/${typeGoal}/${status}/${id}`).then(response => response)
    },
    async getUsersManagers () {
        return await HttpClient.get(`/user/get-manager-type`).then(response => response)
    },

    async getDataGraficaMetas(idMeta){
        return await HttpClient.get(`/goals/get-information-graphic/${idMeta}`).then(response => response)
    },

    async getUsersBySupervisor(id){
        return await HttpClient.get(`/group/get-users-by-supervisor/${id}`).then(response => response)
    },

    async createGoal(data){
        return await HttpClient.postJSON(`/goals/create-goal`, data).then(response => response);
    },

    async updateGoal(data){
        return await HttpClient.postJSON('/goals/update-goal', data).then(response => response);
    }

}